<template>

    <div class="middlebg" :style="{backgroundImage: 'url(' + imgurl + ')',
     backgroundSize:'contain',
     backgroundRepeat:'no-repeat',
     backgroundPosition:'center'}" >
        <!-- <img :src="imgurl" alt="" onclick="return false;"> -->
    </div>
</template>

<script>
    export default {
        name:'mmiddlebg',
        props: ['imgurl','middleItems'],
    }
</script>

<style  scoped>
   
    @media screen and (max-width: 768px){
       
        .middlebg {
           position: relative;
            width: 100%;
            height:37%;
        }
    }
</style>